import React from "react"

export const ArrowRight = () => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.82812 6.375V6.42188C7.92188 6.32812 7.96875 6.1875 7.96875 6C7.96875 5.85938 7.92188 5.71875 7.82812 5.57812L2.29688 0.140625C2.20312 0.046875 2.0625 0 1.92188 0C1.73438 0 1.59375 0.046875 1.5 0.140625L1.17188 0.515625C1.07812 0.609375 1.03125 0.75 1.03125 0.890625C1.03125 1.07812 1.07812 1.21875 1.17188 1.3125L5.95312 6L1.17188 10.6875C1.03125 10.8281 0.984375 10.9688 0.984375 11.1094C0.984375 11.2969 1.03125 11.3906 1.17188 11.4844L1.5 11.8125C1.59375 11.9531 1.73438 12 1.92188 12C2.0625 12 2.20312 11.9531 2.29688 11.8125L7.82812 6.375Z"
        fill="#232323"
      />
    </svg>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icons/ArrowRight.js